import "../sass/project.scss";
import { Tooltip, Popover } from "bootstrap";

/*!
 * Color mode toggler for Bootstrap's docs (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under the Creative Commons Attribution 3.0 Unported License.
 */

(() => {
  'use strict'

  const getStoredTheme = () => localStorage.getItem('theme')
  const setStoredTheme = theme => localStorage.setItem('theme', theme)

  const getPreferredTheme = () => {
    const storedTheme = getStoredTheme()
    if (storedTheme) {
      return storedTheme
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }

  const setTheme = theme => {
    if (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.documentElement.setAttribute('data-bs-theme', 'dark')
    } else {
      document.documentElement.setAttribute('data-bs-theme', theme)
    }
  }

  setTheme(getPreferredTheme())

  const showActiveTheme = (theme, focus = false) => {
    const themeSwitcher = document.querySelector('#bd-theme')

    if (!themeSwitcher) {
      return
    }

    const themeSwitcherText = document.querySelector('#bd-theme-text')
    const activeThemeIcon = document.querySelector('.theme-icon-active use')
    const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`)
    // const svgOfActiveBtn = btnToActive.querySelector('svg use').getAttribute('href')

    document.querySelectorAll('[data-bs-theme-value]').forEach(element => {
      element.classList.remove('active')
      element.setAttribute('aria-pressed', 'false')
    })

    btnToActive.classList.add('active')
    btnToActive.setAttribute('aria-pressed', 'true')
    // activeThemeIcon.setAttribute('href', svgOfActiveBtn)
    const themeSwitcherLabel = `${themeSwitcherText.textContent} (${btnToActive.dataset.bsThemeValue})`
    themeSwitcher.setAttribute('aria-label', themeSwitcherLabel)

    if (focus) {
      themeSwitcher.focus()
    }
  }

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    const storedTheme = getStoredTheme()
    if (storedTheme !== 'light' && storedTheme !== 'dark') {
      setTheme(getPreferredTheme())
    }
  })

  window.addEventListener('DOMContentLoaded', () => {
    showActiveTheme(getPreferredTheme())

    document.querySelectorAll('[data-bs-theme-value]')
      .forEach(toggle => {
        toggle.addEventListener('click', () => {
          const theme = toggle.getAttribute('data-bs-theme-value')
          setStoredTheme(theme)
          setTheme(theme)
          showActiveTheme(theme, true)
        })
      })
  })
})()

document.addEventListener("DOMContentLoaded", function (event) {
  // Initialize all tooltips
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
  );

  // Initialize all popovers
  const popoverTriggerList = document.querySelectorAll(
    '[data-bs-toggle="popover"]'
  );
  const popoverList = [...popoverTriggerList].map(
    (popoverTriggerEl) => new Popover(popoverTriggerEl)
  );

  const radios = document.querySelectorAll("input[type=radio][name=stage]");
  const harvestSlider = document.getElementById("harvestPercentage");
  const harvestLabel = document.getElementById("harvestLabel");
  const profitTarget = document.getElementById("profitTarget");
  const profitTargetLabel = document.getElementById("profitTargetLabel");
  const maxLoss = document.getElementById("maxLoss");
  const maxLossLabel = document.getElementById("maxLossLabel");

  function changeHandler(event) {
    const broker = downloadModal.querySelector("#broker");
    const harvestSlider = downloadModal.querySelector("#harvestSlider");
    const profitTargetSlider = downloadModal.querySelector(
      "#profitTargetSlider"
    );
    const profitTarget = document.getElementById("profitTarget");

    if (this.value == "post-funded") {
      harvestSlider.classList.remove("d-none");
      profitTargetSlider.classList.add("d-none");
    } else {
      harvestSlider.classList.add("d-none");
      profitTargetSlider.classList.remove("d-none");
    }

    if (this.value == "verification") {
      profitTarget.setAttribute("min", 4);
      profitTarget.setAttribute("max", 6);
      profitTarget.setAttribute("step", 1);
      profitTarget.value = 5;
    } else {
      profitTarget.setAttribute("min", 8);
      profitTarget.setAttribute("max", 10);
      profitTarget.setAttribute("step", 2);
      profitTarget.value = (broker.value.includes("FTMO", "Alpari", "FXPIG") ? 10 : 8);
      if(broker.value.includes("VirtualMarkets")) {
        maxLoss.value = 8;
      }
    }

    profitTargetLabel.textContent = `${profitTarget.value}%`;
  }

  Array.prototype.forEach.call(radios, function (radio) {
    radio.addEventListener("change", changeHandler);
  });

  // Download Modal Control
  const downloadModal = document.getElementById("downloadModal");
  if (!downloadModal) {
    return;
  }
  downloadModal.addEventListener("show.bs.modal", (event) => {
    const button = event.relatedTarget;
    const strategyId = button.getAttribute("data-bs-strategy-id");

    const modalTitle = downloadModal.querySelector(".modal-title");
    const modalBodyInput = downloadModal.querySelector(
      ".modal-body #strategyId"
    );

    modalBodyInput.value = strategyId;
  });

  harvestSlider.addEventListener("input", (e) => {
    harvestLabel.textContent = `${e.target.value}%`;
  });

  profitTarget.addEventListener("input", (e) => {
    profitTargetLabel.textContent = `${e.target.value}%`;
  });

  maxLoss.addEventListener("input", (e) => {
    maxLossLabel.textContent = `${e.target.value}%`;
  });
});

const getSelectedAccountSize = () => {
  const accountSizeRadios = document.getElementsByName("account_size");
  let selectedAccountSize = null;
  for (let i = 0; i < accountSizeRadios.length; i++) {
    if (accountSizeRadios[i].checked) {
      selectedAccountSize = accountSizeRadios[i].value;
    }
  }
  return selectedAccountSize;
}

function launchStrategy() {
  const strategyId = document.getElementById("strategyId").value;
  const stageRadios = document.getElementsByName("stage");
  const selectedAccountSize = getSelectedAccountSize();
  const profitTarget = document.getElementById("profitTarget").value;
  const maxLoss = document.getElementById("maxLoss").value;

  let stage = null;
  for (let i = 0; i < stageRadios.length; i++) {
    if (stageRadios[i].checked) {
      stage = stageRadios[i].value;
    }
  }

  if (stage == "post-funded") {
    profitTarget = document.getElementById("harvestPercentage").value;
  }

  let url = new URL(`/${strategyId}/launch/?accountSize=${selectedAccountSize}&profitTarget=${profitTarget}&maxLoss=${maxLoss}`, window.location.origin);
  window.location.assign(url);
}

function downloadEA() {
  const strategyId = document.getElementById("strategyId").value;
  let url = new URL(`/${strategyId}/download/EA/`, window.location.origin);
  window.location.assign(url);
}

function downloadFile(type) {
  const strategyId = document.getElementById("strategyId").value;
  const stageRadios = document.getElementsByName("stage");
  const filterHighImpactNews = document.getElementById("filterHighImpactNews").value;
  const enableHedge = document.getElementById("enableHedge").value;
  let accountSize = getSelectedAccountSize();

  let stage = null;
  for (let i = 0; i < stageRadios.length; i++) {
    if (stageRadios[i].checked) {
      stage = stageRadios[i].value;
    }
  }

  let url = new URL(
    `/${strategyId}/download/${type}/${accountSize}/${stage}/`,
    window.location.origin
  );
  if (stage == "post-funded") {
    url.searchParams.append(
      "harvest_percentage",
      document.getElementById("harvestPercentage").value
    );
  } else {
    url.searchParams.append(
      "profit_target",
      document.getElementById("profitTarget").value
    );
  }
  url.searchParams.append("max_loss", document.getElementById("maxLoss").value);
  url.searchParams.append("mdl_type", document.getElementById("mdlType").value);
  url.searchParams.append("order_comment", document.getElementById("orderComment").value);
  url.searchParams.append(
    "filter_high_impact_news",
    document.getElementById("filterHighImpactNews").value
  );
  url.searchParams.append("enable_hedge", document.getElementById("enableHedge").value);
  url.searchParams.append(
    "mdl_time_override",
    document.getElementById("overrideMdlReset").checked
  );

  window.location.assign(url);
}

window.launchStrategy = launchStrategy;
window.downloadFile = downloadFile;
window.downloadEA = downloadEA;
